<template>
  <div>
    <div v-if="!isMobile" class="home">
      <div class="carousel-wrap">
        <swiper :slides-per-view="1" :space-between="5" autoplay loop :pagination="{ clickable: true }">
          <swiper-slide v-for="(item, index) in bannerList" :key="index">
            <div style="position: relative">
              <img class="bannerImg" style="width: 100%;height: 85vh;" :src="item.image" alt="" />
              <div class="index">
                <div class="index-content animate__animated animate__rotateInDownLeft animate__repeat-1">
                  <h1>{{item.title}}</h1>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      
      <!-- 搜索 -->
      <div class="search_wrap">
        <form action>
          <div class="title">
            <div>以品质之居 致敬城市梦想家</div> 
            <input type="reset" value="清空条件" />
          </div>
          <ul>
            <li>
              <h4>城市</h4>
              <select v-model="provinceActive" @change="changeProvince($event)">
                <option
                  v-for="(item, index) in provinceList"
                  :key="index"
                  :value="item.id"
                >{{item.name}}</option>
              </select>
            </li>
            <li>
              <h4>区域</h4>
              <select v-model="cityActive" @change="changeCity($event)">
                <option
                  v-for="(item, index) in cityList"
                  :key="index"
                  :value="item.id"
                >{{item.name}}</option>
              </select>
            </li>
            <li class="l1">
              <h4>关键字</h4>
              <input type="text" v-model="keyword" placeholder="输入关键字" />
            </li>
            <li class="submit">
              <div class="button" @click="$router.push('/search')">点击搜索</div>
            </li>
          </ul>
        </form>
      </div>
      <!-- 内容1 -->
      <div class="content1">
        <div class="head">
          <h2>
            TO PROVIDE YOU, THE DREAM PURSUERS, A SWEET HOME.
            <br />HOME IS WHERE THE DREAM IS.
          </h2>
          <h3>给追梦的你一个温馨的家——梦在哪 家就在哪</h3>
        </div>
        <ul>
          <li
            v-for="(item, index) in content1"
            :key="index"
            class="wow fadeInUp img"
            :class="item.on ? 'on' : ''"
            :style="{backgroundImage: 'url('+ item.url +')', width: item.width}"
            style="visibility: visible; animation-name: fadeInUp;"
            @mouseover="selectStyle(item, index)"
            @mouseout="outStyle(item, index)"
          >
            <div class="mb"></div>
            <div class="text">
              <div class="ico">
                <img :src="item.icon" alt />
              </div>
              <h3>{{item.h3}}</h3>
              <h4>{{item.h4}}</h4>
            </div>
          </li>
        </ul>
      </div>
      <!-- 内容2 -->
      <div class="content2">
        <div class="head">热门房源推荐</div>
        <div class="box">
          <div class="box_top wow fadeInUp" style="visibility: visible; animation-name: fadeInUp;">
            <div class="text">
              <div>
                <h4><span
                    style="display: inline-block;
                            transform: rotate(90deg);
                            height: 10px;
                            margin-left: -6px;
                            margin-bottom: 17px;
                            margin-right: 10px;
                            margin-top: 50px;"
                  >LINK</span>
                  <span>新界未来社区</span></h4>
                <h5>LINK FUTURE COMMUNITY</h5>
              </div>
            </div>
            <div class="pic">
              <el-carousel @click="toSearch" trigger="click" class="pointer" height="400px">
                <el-carousel-item v-for="(item, index) in lunbolist" :key="index">
                  <img class="bannerImg" :src="item.image" alt />
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <div  class="box_down wow fadeInUp" style="visibility: visible; animation-name: fadeInUp;">
              <div class="hidden">
                <img src="@/assets/img/home2.jpg" alt />
              </div>
          </div>
        </div>
        <div class="box_right wow fadeInUp" style="visibility: visible; animation-name: fadeInUp;">
          <h3>
             <h3>HIGH <br> QUALITY SPACE</h3>
          </h3>
          <h4>高品质空间</h4>
          <div class="pic">
            <div class="hidden">
              <img src="@/assets/img/home1.jpg" alt />
            </div>
              
           
          </div>
          <div
            class="jj"
          >多种房型，多样设计风格，满足创客、单身人士、情侣及家庭等各类人群心中对理想家的风格偏好；空间设计合理，让品质融入生活；配置品质家具、家电，满足日常生活所需，可拎包入住。</div>
          <div class="detail">
            <a class="pointer" @click="$router.push('/search')">发现更多</a>
          </div>
        </div>
      </div>
      <!-- 内容3 -->
      <div class="content3">
        <div class="container">
          <div class="box_left">
            <h3>
              SOCIAL
              <br />COMMONS
            </h3>
            <h4>社交共享空间</h4>
            <div class="pic wow fadeInUp" style="visibility: visible; animation-name: fadeInUp;">
              <div class="hidden">
                <img src="@/assets/img/home3.jpg" alt />
              </div>
            </div>
          </div>
          <div
            class="box_right wow fadeInUp"
            style="visibility: visible; animation-name: fadeInUp;"
          >
            <div class="pic wow fadeInUp">
              <a href>
                <div class="hidden">
                <img class="pic" src="@/assets/img/home4.jpg" alt />
                </div>
              </a>
            </div>
            <div class="jj">
              社区未来为租客提供丰富多彩的社交共享公区，让社区更有温度。功能涵盖咖啡吧、书吧、健身房、共享办公等多个功能区域，完善生活配套，让社区物理空间不断催生化学反应，让租客真正在这座城市享受更高品质生活。
            </div>
          </div>
        </div>
      </div>
      <!-- 内容4 -->
      <div class="content4">
        <div class="container">
          <div class="box_left wow fadeInUp" style="visibility: visible; animation-name: fadeInUp;">
            <div class="pic">
              <div class="hidden">
                <img src="@/assets/img/home6.jpg" alt />
             </div>
            </div>
            <div
              class="jj"
            >针对年轻客群的特性，LINK新界未来社区定期举办厨艺趴、健身局、读书会等系列社群活动，让拥有不同兴趣爱好的租户找到组织，彼此之间因为共同的兴趣爱好而无形拉近彼此的距离，形成温暖的邻里文化。</div>
          </div>
          <div class="box_right">
            <h3>
              RICH COMMUNITY
              <br />ACTIVITIES
            </h3>
            <h4>丰富的社群活动</h4>
            <div class="pic wow fadeInUp">
              <div class="hidden">
                <img src="@/assets/img/home5.jpg" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 内容5 -->
      <div class="content5">
        <div class="container">
          <div class="box_left">
            <h3>
              CUSTOMISED
              <br />EXPERIENCE
            </h3>
            <h4>体贴的配套及服务</h4>
            <div class="pic wow fadeInUp" style="visibility: visible; animation-name: fadeInUp;">
              <div class="hidden">
                <img src="@/assets/img/home8.jpg" alt />
              </div>
            </div>
          </div>
          <div
            class="box_right wow fadeInUp"
            style="visibility: visible; animation-name: fadeInUp;"
          >
            <div class="pic">
              <div class="hidden">
                <img src="@/assets/img/home7.jpg" alt />
             </div>
            </div>
            <div
              class="jj"
            >致力为向往品质格调与精致生活年轻群体提供一个美好的租住产品，社区提供360°全方位贴心配套与服务，社区配套商业街区，拥有智慧停车、智能安防、智慧路灯等“科技”管理方式，还有金牌管家、保洁、24h安保巡逻等，覆盖衣食住行生态圈，为租客的日常生活带来更多美好与可能。</div>
          </div>
        </div>
      </div>
      <!-- 内容6  -->
      <div class="content6">
        <ul class="container">
          <li
            @mouseover="showjj(1, index)"
            @mouseout="showjj(2, index)"
            v-for="(item, index) in content6"
            :key="index"
          >
            <div class="text">
              <h3>{{item.text1}}</h3>
              <h4>{{item.text2}}</h4>
              <h5>{{item.text3}}</h5>
              <div v-show="isShowjj && (jjcur === index)" class="jj">{{item.text4}}</div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 内容7 -->
      <div class="content7">
        <div class="container">
          <div class="box">
            <div class="head">
              新界活动
              <span @click="$router.push('/hui')">查看全部 ></span>
            </div>
            <div class="body">
              <ul>
                <!-- <li @click="jumpTo(tab)" v-for="(tab, index) in navTabs" :key="index">{{tab.name}}</li> -->
                <li v-for="(data, index) in hdData" :key="index" @click="toHui(item)">
                  <div>
                    <div class="top">
                      <!-- <div class="time">2020/04/23</div> -->
                      <div class="time">{{data.release_time_text.substr(0,10)}}</div>
                      <div class="pic">
                        <img class="trans-img" :src="data.image" alt />
                      </div>
                    </div>
                    <div class="text">
                      <div class="title elli">{{data.title}}</div>
                      <!-- <div class="p">
                        <b style="font-weight: normal">{{data.subtitle}}</b>
                        &nbsp;&nbsp;
                        <span>继续关注</span>
                      </div> -->
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <mobile-home></mobile-home>
    </div>
  </div>
</template>

<script>
import {
  getBannerById,
  getProvinceList,
  getCityList,
  getListByTypeId,
  getStoreList
} from "../api/api.js";
import { ElMessage } from "element-plus";
import { baseURL } from "../utils/const.js";
import mobileHome from "./mobile/home.vue";
import SwiperCore, { Pagination, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/swiper.scss'
//这里导入对应样式
import 'swiper/components/pagination/pagination.scss'
//导入后在SwiperCore.use([])里注册
SwiperCore.use([Pagination, Autoplay])

export default {
  name: "Home",
  components: { mobileHome, Swiper, SwiperSlide },
  data() {
    return {
      isMobile: false,
      baseURL,
      hdData: [],
      bannerList: [],
      provinceActive: -1,
      provinceList: [],
      cityActive: -1,
      cityList: [{ id: -1, name: "请选择" }],
      bannerHeight: "",
      keyword: "",
      content1: [
        {
          url: require("@/assets/img/zhixin.jpg"),
          icon: require("@/assets/img/icon/ruzhu-05.jpeg"),
          h3: "SWEET",
          h4: "贴心",
          width: "25%",
          on: false
        },
        {
          url: require("@/assets/img/shuxin.jpg"),
          icon: require("@/assets/img/icon/ruzhu-06.png"),
          h3: "COMFORTABLE",
          h4: "舒心",
          width: "25%",
          on: false
        },
        {
          url: require("@/assets/img/tiexin.jpg"),
          icon: require("@/assets/img/icon/ruzhu-07.png"),
          h3: "BOSOM",
          h4: "知心",
          width: "25%",
          on: false
        },
        {
          url: require("@/assets/img/anxin.jpg"),
          icon: require("@/assets/img/icon/ruzhu-08.png"),
          h3: "RELIEVED",
          h4: "安心",
          width: "25%",
          on: false
        }
      ],
      lunbolist: [],
      content2: [
        {
          // text1: '上海 | 派米雷新界 | 高档公寓',
          // text2: 'shanghai-paimilei-link-department',
          // url: 'http://www.111.net.cn/static/upload/jpg/202004/CJ8A3547%EF%BC%881%EF%BC%89.jpg'
        },
        {
          // text1: '上海 派米雷新界 高档公寓',
          // text2: 'shanghai-paimilei-link-department',
          // url: 'http://www.111.net.cn/static/upload/jpg/202004/CJ8A3576-ins%EF%BC%881%EF%BC%89.jpg'
        }
      ],
      content6: [
        {
          text1: "LINK FUTURE COMMUNITY OF SIJING",
          text2: "LINK新界（泗泾）",
          text3: "未来社区",
          text4:
            "派米雷集团深耕产城融合的首个大型租赁社区。项目位于松江泗泾镇，距9号线泗泾地铁站约1公里。  LINK新界（泗泾）未来社区，围绕都市青年客群定位，引领全新的生活方式，打造绿色、开放、共享、智慧的未来社区。"
        },
        {
          text1: "LINK FUTURE COMMUNITY OF LEDU",
          text2: "LINK新界（乐都）",
          text3: "未来社区",
          text4:
            "派米雷首个商业办公综合体配套租赁住房项目，服务于乐都智慧科创产业园区，置身于松江城区。多款户型、多样设计风格体现人性化理念，同时社区还提供创业全流程服务，打造新型工作+生活一体化的生活空间。"
        },
        {
          text1: "LINK FUTURE COMMUNITY OF CHEDUN",
          text2: "LINK新界（车墩） ",
          text3: "未来社区",
          text4:
            "立足车墩，辐射上海，以车墩影视文化主题为特色，以新海派开放式共享街区为核心，打造集酒店式服务公寓，白领公寓与企业公寓于一体的，综合性大型租赁社区。适配个人或家庭的成长需求为追求生活品质的都市青年提供长期居住的标准化解决方案。"
        }
      ],
      isShowjj: false,
      jjcur: -1
    };
  },
  created() {
    console.log("this.$route", this.$route);
    this.getBannerById(5);
    this.getProvinceList();
    this.getListByTypeId(); //获取活动列表
    this.getStoreList(); // 获取商家列表
  },
  mounted() {
    let flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag) {
      // 手机端
      this.isMobile = true;
    }
    new this.$wow.WOW().init();
  },
  methods: {
    toSearch(){
      this.$router.push({
        path: '/search',
      })
    },
    onSlideChangeStart(){},
    onSlideChangeEnd(){},
    toHui(item) {
      console.log("====");
      this.$router.push({
        path: "/hui",
        query: { item: JSON.stringify(item) }
      });
    },
    async getStoreList() {
      const params = {
        page: 1,
        limit: 4
      };
      const res = await getStoreList(params);
      this.lunbolist = res.data.data;
    },
    async getListByTypeId() {
      //参数
      const params = {
        page: 1,
        limit: 2,
        type_id: 2
      };
      const res = await getListByTypeId(params);
      this.hdData = res.data.data;
    },
    async getBannerById(id) {
      try {
        const res = await getBannerById(id);
        this.bannerList = res.data;
      } catch (err) {
        ElMessage.error(err.message);
      }
    },
    changeProvince(event) {
      this.provinceActive = event.target.value;
      if (event.target.value === "-1") return;
      this.getCityList(this.provinceActive);
    },
    changeCity(event) {
      this.cityActive = event.target.value;
    },
    async getCityList(id) {
      try {
        const res = await getCityList(id);
        this.cityList = res.data ? res.data : [];
        this.cityList.unshift({ id: -1, name: "请选择" });
      } catch (err) {
        ElMessage.error(err.message);
      }
    },
    async getProvinceList() {
      try {
        const res = await getProvinceList();
        this.provinceList = res.data;
        this.provinceList.unshift({ id: -1, name: "请选择" });
      } catch (err) {
        ElMessage.error(err.message);
      }
    },
    showjj(num, index) {
      if (num === 1) {
        if (this.isShowjj) return;
        this.jjcur = index;
        this.isShowjj = true;
      } else {
        this.jjcur = -1;
        this.isShowjj = false;
      }
    },
    selectStyle(val, i) {
      this.content1.map((item, index) => {
        if (i === index) {
          item.width = "40%";
          item.on = true;
        } else {
          item.width = "20%";
        }
      });
    },
    outStyle(val, i) {
      this.content1.map((item, index) => {
        item.width = "25%";
        item.on = false;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.carousel-wrap {
  position: relative;
  .bannerImg {
    object-fit: cover;
    height: 100%;
    width: 100%;
  }
  .index {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.3);
    z-index: 666;
    .index-content {
      width: 100%;
      height: 100%;
      color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      h1 {
        font-size: 40px;
        font-weight: normal;
        letter-spacing: 5px;
        margin-bottom: 20px;
      }
    }
  }
}
.search_wrap {
  width: 100%;
  background: #3b585b;
  color: #fff;
  padding: 40px 20px 63px 20px;
  .title {
    width: 100%;
    line-height: 49px;
    font-size: 28px;
    letter-spacing: 1px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 60px;
    input {
      color: #e5006e;
      font-size: 18px;
      letter-spacing: 1px;
      background: none;
      border: none;
      outline: none;
      height: 34px;
      line-height: 30px;
      border-bottom: 2px solid #e5006e;
    }
  }
  ul {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    li {
      width: 18%;
      h4 {
        font-size: 18px;
        line-height: 28px;
        font-weight: bold;
        letter-spacing: 1px;
        margin-bottom: 20px;
      }
      select {
        width: 100%;
        font-size: 15px;
        letter-spacing: 1px;
        height: 48px;
        line-height: 46px;
        border: 0;
        outline: 0;
        color: rgba(255, 255, 255, 0.5);
        border-bottom: 2px solid rgba(255, 255, 255, 0.5);
        background: transparent;
      }
      input {
        width: 100%;
        font-size: 15px;
        letter-spacing: 1px;
        color: #fff;
        height: 48px;
        line-height: 46px;
        border: 0;
        outline: 0;
        border-bottom: 2px solid rgba(255, 255, 255, 0.5);
        background: transparent;
      }
      ::-webkit-input-placeholder {
        color: rgba(255, 255, 255, 0.5);
        font-size: 15px;
      }
    }
    .submit {
      width: 21%;
      .button {
        width: 100%;
        height: 45px;
        cursor: pointer;
        line-height: 41px;
        font-size: 18px;
        outline: none;
        border: none;
        border: 2px solid #e5006e;
        color: #e5006e;
        border-radius: 23px;
        text-align: center;
        transition: all 0.3s ease-out 0s;
        &:hover {
          color: #fff;
          background: #e5006e;
        }
      }
    }
  }
}
.content1 {
  width: 100%;
  padding: 110px 60px;
  .head {
    width: 100%;
    h2 {
      width: 100%;
      font-size: 26px;
      color: #3b585b;
      line-height: 48px;
      letter-spacing: 1px;
    }
    h3 {
      margin-top: 23px;
      font-size: 24px;
      color: #3b585b;
      line-height: 50px;
      letter-spacing: 1px;
    }
  }
  ul {
    width: 100%;
    margin-top: 60px;
    overflow: hidden;
    .img {
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }
    .on {
      .mb {
        background: #fff;
        opacity: 0.3;
      }
      .text {
        .ico {
          background: #e5006e;
          border: none;
          // border: solid 3px rgba(0,0,0,0.2);
        }
        h3,
        h4 {
          color: #333;
        }
      }
    }
    li {
      float: left;
      height: 540px;
      position: relative;
      overflow: hidden;
      transition: all 0.5s ease-out 0s;
      .mb {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background: #000;
        opacity: 0.4;
        z-index: 1;
        transition: all 0.5s ease-out 0s;
      }
      .text {
        width: 100%;
        text-align: center;
        position: absolute;
        left: 0;
        top: 50%;
        z-index: 2;
        padding: 0 20px;
        transform: translate(0, -40%);
        .ico {
          display: inline-block;
          vertical-align: top;
          width: 90px;
          height: 90px;
          border: solid 3px rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          transition: all 0.5s ease-out 0s;
          img {
            width: 80%;
            height: 80%;
            margin-top: 10px;
          }
        }
        h3 {
          width: 100%;
          margin-top: 20px;
          font-size: 24px;
          line-height: 38px;
          color: #fff;
          transition: all 0.5s ease-out 0s;
          text-align: center;
        }
        h4 {
          font-size: 20px;
          line-height: 30px;
          color: #fff;
          margin-top: 8px;
        }
      }
    }
  }
}
.content2 {
  width: 100%;
  overflow: hidden;
  .head {
    float: left;
    width: 8.66%;
    text-align: center;
    padding: 0 2.5%;
    font-size: 28px;
    color: #3b585b;
    letter-spacing: 2px;
  }
  .box {
    width: 45%;
    float: left;
    margin-left: 1%;
    .box_top {
      width: 100%;
      .text {
        width: 90%;
        float: right;
        background: #f4f1e7;
        height: 406px;
      }
      h4 {
        width: 8.8%;
        padding: 25px 2.5%;
        font-size: 18px;
        color: #3b585b;
        float: right;
      }
      h5 {
        line-height: 60px;
        float: right;
        font-size: 14px;
        color: #3b585b;
        letter-spacing: 1px;
        font-weight: bold;
      }
      .pic {
        width: 90%;
        z-index: 33;
        float: left;
        margin-top: -346px;
        height: 400px;
        .bannerImg {
          width: 100%;
          height: 400px;
        }
      }
    }
    .box_down {
      float: right;
      width: 60%;
      margin-right: 10%;
      margin-top: 30px;
      position: relative;
      img:hover {
        transform: scale(1.1);
      }
      img {
        width: 100%;
        float: left;
        height: 320px;
        position: relative;
        z-index: 2;
        -webkit-transition: all 0.3s linear;
        transition: all 0.3s linear;
      }
    }
    .box_down:before {
      content: "";
      width: 100%;
      height: 100%;
      position: absolute;
      left: -59px;
      top: 59px;
      z-index: 1;
      background: #efd3bb;
    }
  }
  .box_right {
    margin-right: 6%;
    width: 29%;
    float: right;
    h3 {
      margin-top: 22px;
      font-size: 30px;
      line-height: 60px;
      color: #3b585b;
    }
    h4 {
      color: #3b585b;
      text-align: right;
      padding-right: 48px;
      line-height: 60px;
      font-size: 28px;
      margin-top: 40px;
    }
    img:hover {
      transform: scale(1.1, 1.1);
    }
    img {
      width: 100%;
      float: left;
      height: 320px;
      position: relative;
      z-index: 2;
      -webkit-transition: all 0.3s linear;
      transition: all 0.3s linear;
    }
    .pic {
      margin-top: 10px;
      img {
        width: 100%;
        height: 500px;
        float: left;
        -webkit-transition: all 0.3s linear;
        transition: all 0.3s linear;
      }
      img:hover {
        transform: scale(1.1, 1.1);
      }
    }
    .jj {
      margin-top: 53px;
      font-size: 16px;
      color: #3b585b;
      line-height: 28px;
      letter-spacing: 1px;
    }
    .detail {
      margin-top: 40px;
      a {
        display: block;
        float: left;
        font-size: 18px;
        color: #3b585b;
        line-height: 42px;
        letter-spacing: 1px;
        border-bottom: 2px solid #3b585b;
        height: 42px;
        font-weight: bold;
      }
    }
  }
}
.content3 {
  margin-top: 128px;
  position: relative;
  padding-top: 80px;
  overflow: hidden;
  padding-bottom: 100px;
  .container {
    position: relative;
    z-index: 2;
    padding-bottom: 100px;
    // overflow: hidden;
    .box_left {
      width: 30%;
      float: left;
      margin-left: 8%;
      h3 {
        margin-top: 62px;
        font-size: 36px;
        color: #3b585b;
        line-height: 60px;
      }
      h4 {
        margin-top: 21px;
        font-size: 28px;
        color: #3b585b;
        line-height: 60px;
        text-align: right;
        // padding-right: 88px;
      }
      .pic {
        margin-top: 156px;
        width: 100%;
        img {
          width: 100%;
          height: 320px;
          float: left;
          -webkit-transition: all 0.3s linear;
          transition: all 0.3s linear;
        }
        img:hover {
          transform: scale(1.1, 1.1);
        }
      }
    }
    .box_right {
      width: 40%;
      float: right;
      margin-right: 9%;
      .pic {
        z-index: 2;
        width: 100%;
        img {
          width: 100%;
          height: 500px;
          float: left;
          -webkit-transition: all 0.3s linear;
          transition: all 0.3s linear;
        }
        img:hover {
          transform: scale(1.1, 1.1);
        }
      }
      .jj {
        // margin-top: 53px;
        position: relative;
        top: 53px;
        font-size: 16px;
        color: #3b585b;
        line-height: 28px;
        letter-spacing: 1px;
        z-index: 3;
      }
    }
  }
}
.content3:before {
  content: "";
  width: 100%;
  height: 780px;
  background: #f4f1e7;
  z-index: 1;
  position: absolute;
  left: 0;
  top: 0;
}
.content4 {
  width: 100%;
  margin-top: 20px;
  position: relative;
  padding-top: 50px;
  overflow: hidden;
  .container {
    position: relative;
    z-index: 2;
    .box_left {
      float: left;
      margin-right: 0;
      margin-left: 7.9%;
      position: relative;
      width: 40%;
      .pic {
        position: relative;
        z-index: 2;
        width: 100%;
        img {
          width: 100%;
          height: 320px;
          float: left;
          -webkit-transition: all 0.3s linear;
          transition: all 0.3s linear;
        }
        img:hover {
          transform: scale(1.1, 1.1);
        }
      }
      .jj {
        position: relative;
        top: 53px;
        font-size: 16px;
        color: #3b585b;
        line-height: 28px;
        letter-spacing: 1px;
      }
    }
    .box_left:before {
      content: "";
      width: 180px;
      height: 180px;
      background: #efd3bb;
      left: -90px;
      top: -90px;
      position: absolute;
      z-index: 1;
    }
    .box_right {
      margin-left: 0;
      margin-right: 9.8%;
      float: right;
      width: 30%;
      h3 {
        margin-top: 62px;
        font-size: 36px;
        color: #3b585b;
        line-height: 60px;
      }
      h4 {
        margin-top: 21px;
        font-size: 28px;
        color: #3b585b;
        line-height: 60px;
        text-align: right;
        // padding-right: 88px;
      }
      .pic {
        position: relative;
        z-index: 2;
        width: 100%;
        margin-top: 50px;
        img {
          width: 100%;
          height: 320px;
          float: left;
          transition: all 0.3s linear;
        }
        img:hover {
          transform: scale(1.1, 1.1);
        }
      }
    }
  }
}
.content5 {
  margin-top: 128px;
  position: relative;
  padding-top: 80px;
  overflow: hidden;
  padding-bottom: 100px;
  .container {
    position: relative;
    z-index: 2;
    padding-bottom: 100px;
    // overflow: hidden;
    .box_left {
      width: 30%;
      float: left;
      margin-left: 8%;
      h3 {
        margin-top: 62px;
        font-size: 36px;
        color: #3b585b;
        line-height: 60px;
      }
      h4 {
        margin-top: 21px;
        font-size: 28px;
        color: #3b585b;
        line-height: 60px;
        text-align: right;
        // padding-right: 88px;
      }
      .pic {
        margin-top: 156px;
        width: 100%;
        img {
          width: 100%;
          height: 320px;
          float: left;
          -webkit-transition: all 0.3s linear;
          transition: all 0.3s linear;
        }
        img:hover {
          transform: scale(1.1, 1.1);
        }
      }
    }
    .box_right {
      width: 40%;
      float: right;
      margin-right: 9%;
      .pic {
        z-index: 2;
        width: 100%;
        img {
          width: 100%;
          height: 660px;
          float: left;
          -webkit-transition: all 0.3s linear;
          transition: all 0.3s linear;
        }
        img:hover {
          transform: scale(1.1, 1.1);
        }
      }
      .jj {
        position: relative;
        top: 53px;
        font-size: 16px;
        color: #3b585b;
        line-height: 28px;
        letter-spacing: 1px;
        z-index: 3;
      }
    }
  }
}
.content5:before {
  content: "";
  width: 100%;
  height: 780px;
  background: #f4f1e7;
  z-index: 1;
  position: absolute;
  left: 0;
  top: 0;
}
.content6 {
  margin-top: 80px;
  .container {
    cursor: pointer;
    display: flex;
    flex: 1;
    li {
      width: 33.33%;
      height: 520px;
      position: relative;
      transition: all 0.5s ease-out 1s;
      padding: 0 5%;
      .text {
        width: 100%;
        height: 100%;
        // color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        h3 {
          letter-spacing: -0.5px;
          line-height: 38px;
          white-space: nowrap;
          font-size: 18px;
        }
        h4 {
          margin-top: 13px;
          font-size: 30px;
          line-height: 38px;
        }
        h5 {
          margin-top: 35px;
          font-size: 18px;
          line-height: 27px;
          letter-spacing: 1px;
        }
        .jj {
          font-size: 16px;
          line-height: 30px;
          letter-spacing: 1px;
          min-height: 270px;
          overflow-y: auto;
        }
      }
      &:nth-child(1) {
        color: #3b585b;
        background: #f4f1e7;
      }
      &:nth-child(2) {
        background: #e0d8bb;
        color: #3b585b;
      }
      &:nth-child(3) {
        color: #3b585b;
        background: #f4f1e7;
      }
    }
  }
}
.content7 {
  width: 100%;
  overflow: hidden;
  .container {
    padding: 70px 0 70px 0;
    overflow: hidden;
    .box {
      padding: 0 100px;
      .head {
        width: 100%;
        font-size: 28px;
        color: #3b585b;
        line-height: 50px;
        letter-spacing: 1px;
        float: left;
        margin-bottom: 60px;
        span {
          float: right;
          font-size: 16px;
          color: #d57d4f;
          margin-top: 9px;
          line-height: 34px;
          border-bottom: 2px solid #d57d4f;
          cursor: pointer;
        }
      }
      .body {
        ul {
          margin-top: 54px;
          overflow: hidden;
          li {
            cursor: pointer;
            width: 48%;
            float: left;
            display: flex;
            flex-direction: row;
            margin-right: 10px;
            .top {
              .time {
                width: 90px;
                height: 14px;
                line-height: 14px;
                font-size: 16px;
                color: #3b585b;
                transform: rotate(-90deg);
                transform-origin: 100% 0;
                margin-left: -120px;
                letter-spacing: -1px;
              }
              .pic {
                img {
                  width: 362px;
                  height: 203px;
                }
                img:hover {
                  transform: scale(1.1, 1.1);
                }
              }
            }
            .text {
              margin-top: 15px;
              .title {
                font-size: 16px;
                color: #3b585b;
                line-height: 32px;
                letter-spacing: 1px;
              }
              .elli {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .p {
                margin-top: 19px;
                font-size: 14px;
                color: #3b585b;
                line-height: 24px;
                letter-spacing: 1px;
                height: 72px;
                display: -webkit-box;
                text-overflow: ellipsis;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                word-break: break-all;
                span {
                  color: #d57d4f;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
